<template>
  <div>
    <header class="main-header">
      <div class="main-header-wrapper container">
        <div class="logo-wrapper">
          <router-link :to="{ name: 'dashboard' }">
            <img :src="getLogoUrl()" :alt="getCompanyText('company_shortname')" class="logo" />
          </router-link>
        </div>
        <navigation />
      </div>
    </header>
    <div class="content-wrapper container">
      <router-view />
    </div>
    <footer class="footer">
      <div class="footer-wrapper container">
        <div class="row">
          <div class="col-12 col-md-4">
            <span>
              <b class="color-yellow" v-html="getCompanyText('company_fullname')" /><br />
              <small class="color-light-gray" v-if="getCompanyText('footer_company_idno')">IČO: {{ getCompanyText('footer_company_idno') }}</small><br v-if="getCompanyText('footer_company_idno')" />
              <small class="color-light-gray">
                <font-awesome-icon
                  :icon="['fas', 'map-marker-alt']"
                  class="color-yellow mr-1"
                />{{ getCompanyText('company_address') }}
              </small>
              <br />
              <small>
                <a class="color-light-gray" :href="'mailto:' + getCompanyText('company_email')">
                  <font-awesome-icon
                    :icon="['far', 'envelope']"
                    class="color-yellow mr-1"
                  />
                  {{ getCompanyText('company_email') }}
                </a>
              </small>
              <br />
              <small v-if="getCompanyText('company_phone')">
                <a class="color-light-gray" :href="'tel:' + getCompanyText('company_phone')">
                  <font-awesome-icon
                    :icon="['fas', 'phone']"
                    class="color-yellow mr-1"
                  />
                  {{ getCompanyText('company_phone') }}
                </a>
              </small>
            </span>
          </div>
        </div>
        <div class="footer-info color-light-gray text-justify mt-4 font-italic" v-html="getCompanyText('footer_text')" />
      </div>
    </footer>
  </div>
</template>

<script>
import Navigation from "../../components/Navigation";
import { token } from "@/store/modules/account";
import store from "@/store";

export default {
  name: "Private",
  components: {
    Navigation
  },
  beforeRouteEnter(to, from, next) {
    if (!token()) {
      next({ name: "login" });
    } else {
      store.dispatch("account/assignedToMe").then(() => {
        store.dispatch("account/getProfileInfo").then(() => {
          next();
        });
      });
    }
  },
  mounted() {
    this.$store.dispatch("portfolio/portfolios");
    this.$store.dispatch("instructions/availableStrategies");
    this.$store.dispatch("instructions/sellStrategies");
    this.$store.dispatch("instructions/withdrawalStrategies");
  },
  computed: {
    intermediary() {
      return this.$store.state.content.intermediary;
    }
  }
};
</script>

<style lang="scss">
.content-wrapper {
  padding-bottom: 50px;
  min-height: 80vh;

  @include media-breakpoint-down(lg) {
    margin-top: 100px;
  }
}

.main-header {
  background: $dark-gray;
  margin-bottom: 40px;

  @include media-breakpoint-down(lg) {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 90;
    margin-bottom: 0;
  }

  .main-header-wrapper {
    display: flex;
    align-items: stretch;

    .logo-wrapper {
      margin-right: 40px;
      margin-top: 10px;

      a {
        display: block;
        padding-top: 10px;
        padding-bottom: 10px;

        .logo {
          height: 30px;

          @include media-breakpoint-down(md) {
            height: 40px;
          }
        }

        img {
          max-height: 40px !important;
        }
      }
    }
  }

  .submenu-wrapper {
    margin-left: auto;

    @include media-breakpoint-down(lg) {
      margin-left: 0;
    }

    .btn {
      position: relative;
      outline: none;
      box-shadow: none;

      .badge {
        $badgeSize: 18px;
        position: absolute;
        top: 0;
        background: $yellow;
        right: 0;
        height: $badgeSize;
        min-width: $badgeSize;
        border-radius: $badgeSize/2;
        font-size: 11px;
      }
    }
  }

  .menu-wrapper {
    .navbar-nav {
      .nav-item {
        position: relative;
        height: 70px;

        .nav-link {
          padding: 0 5px;
          margin: 12px 10px;
          line-height: 40px;
          height: 40px;
          color: #fff;
          //text-transform: uppercase;
          border-bottom: 2px solid transparent;
          font-size: 18px;

          &.router-link-exact-active {
            color: $yellow;
            //text-decoration: underline;
            border-color: $yellow;
          }
        }

        @include media-breakpoint-up(xl) {
          &:not(:hover) {
            > ul {
              display: none;
            }
          }
        }

        > ul {
          list-style: none;
          padding: 5px 30px 15px 30px;
          position: absolute;
          width: 220px;
          background: $medium-gray;
          z-index: 30;
          top: 100%;
          border-top: 5px solid $medium-gray;

          &.settings {
            width: 150px;
            padding: 5px 25px 15px 25px;
          }

          li {
            a {
              display: block;
              color: #fff;
              font-size: 13px;
              line-height: 120%;
              padding: 15px 0;

              &:hover {
                color: $yellow;
                background-color: $medium-gray;
                text-decoration: none;
              }
            }

            &:not(:first-child) a {
              border-top: 1px solid #191919;
            }
          }
        }

        > ul:not(.dropdown-menu) {
          @include media-breakpoint-down(lg) {
            display: block;
            position: relative !important;
            width: 100% !important;
          }
        }

        > ul.dropdown-menu {
          @include media-breakpoint-down(lg) {
            position: relative !important;
            width: 100% !important;
            transform: none !important;

            a {
              text-overflow: ellipsis;
              overflow: hidden;
            }
          }
        }
      }

      .users-wrapper {
        max-height: 300px !important;
        overflow-y: auto;
      }

      .users-wrapper::-webkit-scrollbar {
        background-color: #373737;
      }

      .users-wrapper::-webkit-scrollbar-thumb {
        background-color: white;
      }

      .users-wrapper-mobile {
        ul {
          max-height: 200px !important;
          overflow-y: auto;
        }

        .nav-link {
          text-transform: capitalize;
        }
      }
    }
  }
}

.footer {
  background: $dark-gray;
  position: static;
  bottom: 0;
  left: 0;
  right: 0;

  .footer-wrapper {
    padding: 30px 15px;

    .footer-info {
      font-size: 10px;
    }
  }
}
</style>
